function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { array, isArray, isObject, isString } from 'vega-util';
import { isBinned } from '../../../bin';
import { getMainRangeChannel, isXorY, THETA, RADIUS } from '../../../channel';
import { defaultTitle, getFieldDef, getFormatMixins, hasConditionalFieldDef, isFieldDef, isTypedFieldDef, vgField } from '../../../channeldef';
import { forEach } from '../../../encoding';
import { entries } from '../../../util';
import { isSignalRef } from '../../../vega.schema';
import { getMarkPropOrConfig } from '../../common';
import { binFormatExpression, formatSignalRef } from '../../format';
import { wrapCondition } from './conditional';
import { textRef } from './text';
export function tooltip(model) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var encoding = model.encoding,
    markDef = model.markDef,
    config = model.config,
    stack = model.stack;
  var channelDef = encoding.tooltip;
  if (isArray(channelDef)) {
    return {
      tooltip: tooltipRefForEncoding({
        tooltip: channelDef
      }, stack, config, opt)
    };
  } else {
    var datum = opt.reactiveGeom ? 'datum.datum' : 'datum';
    var mainRefFn = function mainRefFn(cDef) {
      // use valueRef based on channelDef first
      var tooltipRefFromChannelDef = textRef(cDef, config, datum);
      if (tooltipRefFromChannelDef) {
        return tooltipRefFromChannelDef;
      }
      if (cDef === null) {
        // Allow using encoding.tooltip = null to disable tooltip
        return undefined;
      }
      var markTooltip = getMarkPropOrConfig('tooltip', markDef, config);
      if (markTooltip === true) {
        markTooltip = {
          content: 'encoding'
        };
      }
      if (isString(markTooltip)) {
        return {
          value: markTooltip
        };
      } else if (isObject(markTooltip)) {
        // `tooltip` is `{fields: 'encodings' | 'fields'}`
        if (isSignalRef(markTooltip)) {
          return markTooltip;
        } else if (markTooltip.content === 'encoding') {
          return tooltipRefForEncoding(encoding, stack, config, opt);
        } else {
          return {
            signal: datum
          };
        }
      }
      return undefined;
    };
    return wrapCondition({
      model: model,
      channelDef: channelDef,
      vgChannel: 'tooltip',
      mainRefFn: mainRefFn,
      invalidValueRef: undefined // tooltip encoding doesn't have continuous scales and thus can't have invalid values
    });
  }
}
export function tooltipData(encoding, stack, config) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    reactiveGeom = _ref.reactiveGeom;
  var formatConfig = _objectSpread(_objectSpread({}, config), config.tooltipFormat);
  var toSkip = new Set();
  var expr = reactiveGeom ? 'datum.datum' : 'datum';
  var tuples = [];
  function add(fDef, channel) {
    var mainChannel = getMainRangeChannel(channel);
    var fieldDef = isTypedFieldDef(fDef) ? fDef : _objectSpread(_objectSpread({}, fDef), {}, {
      type: encoding[mainChannel].type // for secondary field def, copy type from main channel
    });
    var title = fieldDef.title || defaultTitle(fieldDef, formatConfig);
    var key = array(title).join(', ').replaceAll(/"/g, '\\"');
    var value;
    if (isXorY(channel)) {
      var channel2 = channel === 'x' ? 'x2' : 'y2';
      var fieldDef2 = getFieldDef(encoding[channel2]);
      if (isBinned(fieldDef.bin) && fieldDef2) {
        var startField = vgField(fieldDef, {
          expr: expr
        });
        var endField = vgField(fieldDef2, {
          expr: expr
        });
        var _getFormatMixins = getFormatMixins(fieldDef),
          format = _getFormatMixins.format,
          formatType = _getFormatMixins.formatType;
        value = binFormatExpression(startField, endField, format, formatType, formatConfig);
        toSkip.add(channel2);
      }
    }
    if ((isXorY(channel) || channel === THETA || channel === RADIUS) && stack && stack.fieldChannel === channel && stack.offset === 'normalize') {
      var _getFormatMixins2 = getFormatMixins(fieldDef),
        _format = _getFormatMixins2.format,
        _formatType = _getFormatMixins2.formatType;
      value = formatSignalRef({
        fieldOrDatumDef: fieldDef,
        format: _format,
        formatType: _formatType,
        expr: expr,
        config: formatConfig,
        normalizeStack: true
      }).signal;
    }
    value !== null && value !== void 0 ? value : value = textRef(fieldDef, formatConfig, expr).signal;
    tuples.push({
      channel: channel,
      key: key,
      value: value
    });
  }
  forEach(encoding, function (channelDef, channel) {
    if (isFieldDef(channelDef)) {
      add(channelDef, channel);
    } else if (hasConditionalFieldDef(channelDef)) {
      add(channelDef.condition, channel);
    }
  });
  var out = {};
  for (var _i = 0, _tuples = tuples; _i < _tuples.length; _i++) {
    var _ref2 = _tuples[_i];
    var channel = _ref2.channel;
    var key = _ref2.key;
    var value = _ref2.value;
    if (!toSkip.has(channel) && !out[key]) {
      out[key] = value;
    }
  }
  return out;
}
export function tooltipRefForEncoding(encoding, stack, config) {
  var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    reactiveGeom = _ref3.reactiveGeom;
  var data = tooltipData(encoding, stack, config, {
    reactiveGeom: reactiveGeom
  });
  var keyValues = entries(data).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return "\"".concat(key, "\": ").concat(value);
  });
  return keyValues.length > 0 ? {
    signal: "{".concat(keyValues.join(', '), "}")
  } : undefined;
}